<template>
  <keep-alive>
    <div>
      <div v-if="mobil_banners.length">
        <div class="mobil_banner" v-for="(item,index) in mobil_banners">
          <img :src="item" :alt="index">
        </div>
      </div>
      <div class="swiper-container" v-if="banners.length">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in banners" :key="index">
            <img style="width: 100%;height: 100%" v-if="item.endsWith('.gif') || item.endsWith('.png') || item.endsWith('.jpg') || item.endsWith('.jpeg')" :src="item" alt="pic">
            <video autoplay muted loop width="100%" height="100%" v-if="item.endsWith('.mp4')">
              <source :src="item" type="video/mp4">
              抱歉，您的浏览器暂不支持该视频格式！
            </video>
          </div>
        </div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
  </keep-alive>
</template>

<script>
import Swiper from "swiper4/js/swiper";
import 'swiper4/css/swiper.css';

import $ from "jquery";
import * as oaim from '../../static/js/oaim.js'
import Video from "../views/video/Video.vue";

export default {
  name: 'Index',
  components: {Video},
  data() {
    return {
      msg: 'Welcome to oaim',
      oaim: [],
      currentIndex: -1,
      timer: 0, //定时器

      banners: [],
      mobil_banners:[],
      // picWidth: 1880
    }
  },
  methods: {
    getBanners() {
      this.$axios.get('/back/carousel/list').then(res => {
        let data = res.data.data
        this.banners = data.map(item => item.picUrl)

        setTimeout(() => {
          new Swiper('.swiper-container', {
            effect: 'fade',
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            },
            autoplay: {
              delay: 3000,
              stopOnLastSlide: true,
              disableOnInteraction: false
            },
            speed: 0,
            loop: true,
            observer: true,
            observeParents: true,
          })
        }, 500)

      }).catch(err => {
        console.log(err)
      })
    },
    getMobilBanners(){
      this.$axios.get('/back/carousel/list').then(res => {
        let data = res.data.data
        this.mobil_banners = data.map(item => item.picUrl)
      }).catch(err => {
        console.log(err)
      })
    }
  },
  mounted() {
    let res = $(window).width()
    if (res < 1000){
      this.getMobilBanners()
    }else {
      this.getBanners()
    }


  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
}

.mobil_banner img{
  width: 100%;
  height: 100%;
}

.swiper-pagination >>> .swiper-pagination-bullet-active {
  background: #ff6600 !important;
}

.swiper-pagination >>> .swiper-pagination-bullet {
  opacity: 1;
  background-color: white;
}

.swiper-container >>> .swiper-button-prev {
  background-image: url("http://qiniu.shujunjun.club/left3.png");
  background-size: 100% auto;
  margin-left: 3%;
}

.swiper-container >>> .swiper-button-next {
  background-image: url("http://qiniu.shujunjun.club/right3.png");
  background-size: 100% auto;
  margin-right: 3%;
}

.swiper-slide {
  width: 100%;
  height: 100%;
  /*min-height: 880px;*/
}

.swiper-button-prev:after, .swiper-button-next:after {
  font-size: 14px;
}

.swiper-slide > img {
  height: auto;
  width: 100%;
}

.swiper-pagination {
  color: #dc6224;
}

@media (min-width: 100px) and (max-width: 700px) {
  .swiper-slide > img{
    /*width: 200% !important;*/
    /*height: 300% !important;*/
    /*-webkit-transform: scale(1.5,1.5);*/
    /*-moz-transform: scale(1.5,1.5);*/
    /*transform:scale(1.5,1.5);*/
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue